import { AsyncImage, IAsyncImageProps } from 'components/ui';

export const SequoiaOneIcon = ({
  height = 16,
  width = 16,
  ...rest
}: IAsyncImageProps) => {
  return (
    <AsyncImage
      alt=""
      height={height}
      src="/images/sequoia-one-logo.png"
      width={width}
      {...rest}
    />
  );
};
